import { Box, ClickAwayListener,Dialog } from '@material-ui/core';
import img from '../../../../../../../static/images/MapPopup.png'


const MappingPopups = ({ open, handleClose }) => {
  return (
    <ClickAwayListener>
      <Dialog open={open} onClose={handleClose}>
        <Box>
        <img src={img}/> 
        </Box>
      </Dialog>
    </ClickAwayListener>
  );
};

export default MappingPopups;
